<template>
  <BaseWarning>
    <i18n path="warnings.tacticalRisk.warning" tag="span">
      <template #moreImplemented>{{ $t(riskImplemented.more) }}</template>
      <template #lessImplemented>{{ $t(riskImplemented.less) }}</template>
      <template #possessionType>
        <i>{{ $t(`tactics.possession.${data.possessionType}`) }}</i>
      </template>
      <template #instructions>
        <a :href="instructionsURL" target="_blank">
          {{ $t('warnings.tacticalRisk.instructions') }}
        </a>
      </template>
      <template #effect>
        <a :href="effect.url" target="_blank">{{ $t(effect.path) }}</a>
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from './BaseWarning'

export default {
  name: 'WarningTacticalRisk',

  props: {
    data: Object
  },

  components: { BaseWarning },

  data: function() {
    return {
      instructionsURL: "https://www.guidetofm.com/tactics/team-player-instructions/#playing-style-composition",
      effects: {
        inPossession: [
          { path: 'warnings.tacticalRisk.keepingPossession', 
            url: "https://www.guidetofootball.com/tactics/attacking-objectives/#keeping-possession" },
          { path: 'warnings.tacticalRisk.creatingSpace', 
            url: "https://www.guidetofootball.com/tactics/attacking-objectives/#creating-space" }
        ],
        outOfPossession: [
          { path: 'warnings.tacticalRisk.protectingSpace', 
            url: "https://www.guidetofootball.com/tactics/defensive-objectives/#protecting-space" },
          { path: 'warnings.tacticalRisk.restrictingSpace', 
            url: "https://www.guidetofootball.com/tactics/defensive-objectives/#restricting-space" }
        ]
      },
      higherRiskPath: "warnings.tacticalRisk.higherRisk",
      lowerRiskPath: "warnings.tacticalRisk.lowerRisk"
    };
  },
  
  computed: {
    effect: function() {
      return this.effects[this.data.possessionType][this.data.netRisk < 0 ? 0 :1];
    },
    riskImplemented: function() {
      if (this.data.netRisk < 0) {
        return { more: this.lowerRiskPath, less: this.higherRiskPath };
      }
      return { more: this.higherRiskPath, less: this.lowerRiskPath };
    }
  }
}
</script>
